
import Button from '../../../components/base/Button';

export default function ServicesSection() {
  const services = [
    {
      icon: 'ri-arrow-up-down-line',
      title: 'Telescopic Bollards',
      description: 'Discreet bollards dug into the ground offering the best type of vehicle protection. Professional underground installation with superior security.',
      features: ['Underground installation', 'Discreet appearance', 'Maximum vehicle protection', 'Professional excavation'],
      image: 'https://public.readdy.ai/ai/img_res/71d4ff19d1e5c77ae6a0cd5db7880e54.jpg',
      category: 'Premium Protection'
    },
    {
      icon: 'ri-hammer-line',
      title: 'Fold Down Bollards',
      description: 'More affordable option that bolts onto your existing drive. Quick installation without excavation, perfect for budget-conscious customers.',
      features: ['Bolts to existing surface', 'Affordable installation', 'No excavation required', 'Quick setup'],
      image: 'https://readdy.ai/api/search-image?query=Fold%20down%20security%20bollards%20bolted%20to%20concrete%20driveway%20surface%2C%20affordable%20vehicle%20protection%20solution%20with%20hinged%20mechanism%2C%20residential%20installation%20on%20existing%20drive&width=400&height=300&seq=fold-down-bollards&orientation=landscape',
      category: 'Budget Friendly'
    },
    {
      icon: 'ri-flashlight-line',
      title: 'Electric Bollards',
      description: 'Higher end driveway protection that adds a luxury look to your drive. Automated operation with premium aesthetics and advanced features.',
      features: ['Automated operation', 'Luxury appearance', 'Remote control access', 'Premium materials'],
      image: 'https://readdy.ai/api/search-image?query=Luxury%20electric%20automatic%20bollards%20with%20LED%20lighting%20in%20upscale%20residential%20driveway%2C%20premium%20vehicle%20protection%20system%20with%20remote%20control%20operation%2C%20high-end%20security%20installation&width=400&height=300&seq=electric-bollards&orientation=landscape',
      category: 'Luxury Solution'
    }
  ];

  return (
    <section id="services" className="py-20 bg-gray-900">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Our Bollard <span className="text-yellow-500">Solutions</span>
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Professional bollard installation for residential and commercial properties in Essex. Choose from our three specialized bollard types.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-black/50 backdrop-blur-sm rounded-xl p-6 border border-yellow-500/20 hover:border-yellow-500/40 transition-all duration-300">
              <div className="mb-6">
                <img 
                  src={service.image} 
                  alt={service.title}
                  className="w-full h-48 object-cover object-top rounded-lg"
                />
              </div>
              
              <div className="mb-4">
                <span className="inline-block bg-yellow-500/20 text-yellow-500 text-xs px-3 py-1 rounded-full mb-3">
                  {service.category}
                </span>
                <div className="flex items-center mb-3">
                  <div className="w-12 h-12 bg-yellow-500 rounded-lg flex items-center justify-center mr-4">
                    <i className={`${service.icon} text-black text-xl`}></i>
                  </div>
                  <h3 className="text-xl font-semibold text-white">{service.title}</h3>
                </div>
              </div>
              
              <p className="text-gray-300 mb-4">{service.description}</p>
              
              <ul className="space-y-2 mb-6">
                {service.features.map((feature, idx) => (
                  <li key={idx} className="flex items-center text-gray-400">
                    <i className="ri-check-line text-yellow-500 mr-2"></i>
                    {feature}
                  </li>
                ))}
              </ul>
              
              <a href="tel:+447834858178" className="w-full inline-block bg-transparent border border-yellow-500 text-yellow-500 px-4 py-2 rounded-lg text-sm font-semibold hover:bg-yellow-500 hover:text-black transition-colors whitespace-nowrap cursor-pointer text-center">
                Get Quote
              </a>
            </div>
          ))}
        </div>

        {/* Additional Service Information */}
        <div className="mt-16 bg-black/30 rounded-xl p-8 border border-yellow-500/20">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
            <div>
              <h3 className="text-2xl font-bold text-white mb-4">
                Professional Installation Process
              </h3>
              <div className="space-y-4">
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-yellow-500 rounded-full flex items-center justify-center mr-4 mt-1">
                    <span className="text-black font-bold text-sm">1</span>
                  </div>
                  <div>
                    <h4 className="text-white font-semibold mb-1">Site Assessment</h4>
                    <p className="text-gray-400 text-sm">Free consultation and detailed site survey to determine the best bollard solution for your property.</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-yellow-500 rounded-full flex items-center justify-center mr-4 mt-1">
                    <span className="text-black font-bold text-sm">2</span>
                  </div>
                  <div>
                    <h4 className="text-white font-semibold mb-1">Custom Design</h4>
                    <p className="text-gray-400 text-sm">Tailored bollard configuration based on your security needs and aesthetic preferences.</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-yellow-500 rounded-full flex items-center justify-center mr-4 mt-1">
                    <span className="text-black font-bold text-sm">3</span>
                  </div>
                  <div>
                    <h4 className="text-white font-semibold mb-1">Professional Installation</h4>
                    <p className="text-gray-400 text-sm">Expert installation by certified technicians with minimal disruption to your property.</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-yellow-500 rounded-full flex items-center justify-center mr-4 mt-1">
                    <span className="text-black font-bold text-sm">4</span>
                  </div>
                  <div>
                    <h4 className="text-white font-semibold mb-1">Testing & Handover</h4>
                    <p className="text-gray-400 text-sm">Comprehensive testing and training on operation, plus ongoing maintenance support.</p>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div className="bg-yellow-500/10 rounded-lg p-6 border border-yellow-500/20">
                <h4 className="text-xl font-bold text-white mb-4">Why Choose Our Bollards?</h4>
                <ul className="space-y-3">
                  <li className="flex items-center text-gray-300">
                    <i className="ri-shield-check-line text-yellow-500 mr-3"></i>
                    Crash-tested to PAS 68 standards
                  </li>
                  <li className="flex items-center text-gray-300">
                    <i className="ri-tools-line text-yellow-500 mr-3"></i>
                    Professional installation guarantee
                  </li>
                  <li className="flex items-center text-gray-300">
                    <i className="ri-time-line text-yellow-500 mr-3"></i>
                    5-year comprehensive warranty
                  </li>
                  <li className="flex items-center text-gray-300">
                    <i className="ri-customer-service-line text-yellow-500 mr-3"></i>
                    24/7 emergency support
                  </li>
                  <li className="flex items-center text-gray-300">
                    <i className="ri-medal-line text-yellow-500 mr-3"></i>
                    CSCS certified installers
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="text-center mt-12">
          <div className="bg-black/30 rounded-xl p-8 border border-yellow-500/20">
            <h3 className="text-2xl font-bold text-white mb-4">
              Residential &amp; Commercial Installation
            </h3>
            <p className="text-gray-300 mb-6">
              We provide professional bollard installation services for both residential driveways and commercial properties throughout Essex.
            </p>
            <a href="tel:+447834858178" className="inline-block bg-yellow-500 text-black px-8 py-4 rounded-lg text-lg font-semibold hover:bg-yellow-400 transition-colors whitespace-nowrap cursor-pointer">
              Free Site Assessment
              <i className="ri-arrow-right-line ml-2"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
